<template>
  <div>
    <div class="tc-content">
      <Logo v-if="logo" class="tc-logo" :logo="logo" :size="30" />
      <div class="tc-label">
        {{ label }}
        <LearnMore class="help-icon" v-if="help" :help="help" />
      </div>
      <slot name="toggle" />
    </div>
    <div class="tc-description mt-3">
      <slot name="description">{{ description }}</slot>
    </div>
  </div>
</template>

<script>
import LearnMore from "@/components/display/LearnMore";
import Logo from "@/components/display/Logo";
export default {
  name: "ToggleCard",
  components: { LearnMore, Logo },
  props: {
    logo: String,
    label: String,
    description: String,
    help: {
      type: Object,
    },
  },
  setup() {},
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.tc-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  .tc-logo {
    margin-right: 10px;
  }

  .tc-label {
    flex-grow: 14;
    font-weight: bold;
    letter-spacing: 0.12px;
    font-size: 1rem;
    padding-top: 0.1rem;
  }

  .tc-description {
    font-size: 0.875rem;
  }

  .help-icon {
    display: inline-flex;
    vertical-align: sub;
  }
}
</style>
